import { observable, action, computed, runInAction } from "mobx";

export default class CreateBranchStore {

  constructor(http, projectOwnerStore) {
    this.http = http;
    this.projectOwnerStore = projectOwnerStore;
  }

  @observable bool_showCreateBranchModal = false;

  @observable
  po_ob_jsonConfig = {
    actionType: "CreateBranch",
    branch: {
      mid: "",
      pid: "",
      name: "",
      description: "",
    },
    dictionaryAdministrators: []
  };
  @observable.ref po_ob_jsonConfig_reset = { ...this.po_ob_jsonConfig };

  @action
  po_action_send_createBranch_req = () => {
    runInAction(() => {
      this.http.func_sendGeneralMessage(this.po_ob_jsonConfig, response => {
        this.po_ob_jsonConfig = this.po_ob_jsonConfig_reset;
        this.po_ui_action_createBranch_mod_visib();
      });
    });
  };

  @action
  po_action_createJSON_conf_CreateBranch = (value, field) => {
    this.po_ob_jsonConfig.branch[field] = value;
  };

  @action
  po_action_provide_projectIds = (mid, pid, daId) => {
    this.po_ob_jsonConfig = {
      ...this.po_ob_jsonConfig,
      branch: {
        ...this.po_ob_jsonConfig.branch,
        mid: mid,
        pid: pid
      },
      dictionaryAdministrators: [daId]
    };
  };

  @action
  po_ui_action_createBranch_mod_visib = () => {
    this.bool_showCreateBranchModal = !this.bool_showCreateBranchModal;
    this.po_ob_jsonConfig.branch.name = "";
    this.po_ob_jsonConfig.branch.description = "";
  };

  @computed
  get po_computed_visib_CreateBranchMod() {
    return this.bool_showCreateBranchModal;
  }

  @computed
  get po_computed_name_len_error_valid() {
    return this.po_ob_jsonConfig.branch.name.length > 0 ? "success" : "error";
  }
}
